<template>
    <div
        v-if="applePayAvailable"
        class="apple-pay-button apple-pay-button-black"
        @click="onClickHandler"
    ></div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import { createMerchantSession } from "../../../../api/modules/applepay";

    export default {
        name: "ApplePayCheckoutButton",
        data: () => ({
            applePayAvailable: false,
            session: null
        }),
        computed: {
            getTotalAmountString() {
                const priceKrone = this.$store.getters["order/getPriceOre"] / 100;
                return priceKrone.toString();
            },
            isPriceValid() {
                const price = this.$store.getters["order/getPriceOre"];
                return price && !Number.isNaN(price);
            },
            ...mapGetters({
                getApplePayEnabled: "system/getApplePayEnabled",
                getMerchantId: "system/getApplePayMerchantId",
                getMerchantName: "system/getCompanyName",
                getMerchantCapabilities: "system/getApplePayMerchantCapabilities",
                getSupportedNetworks: "system/getApplePaySupportedNetworks"
            })
        },
        mounted() {
            if (window.ApplePaySession) {
                this.applePayAvailable = this.getApplePayEnabled && window.ApplePaySession.canMakePayments() && this.isPriceValid;
                if (!this.isPriceValid) {
                    console.error(`Invalid price: ${this.getTotalAmountString}`)
                }
            }
        },
        methods: {
            getApplePayPaymentRequest() {
                return {
                    merchantCapabilities: this.getMerchantCapabilities,
                    supportedNetworks: this.getSupportedNetworks,
                    countryCode: "DK",
                    total: {
                        label: this.getMerchantName,
                        amount: this.getTotalAmountString,
                        type: "final"
                    },
                    currencyCode: "DKK"
                };
            },
            onValidateMerchant() {
                console.log("on validate merchant")
                createMerchantSession()
                    .then(response => {
                            let sessionObject = JSON.parse(response.responseBody.session);
                            this.session.completeMerchantValidation(sessionObject);
                        }
                    )
                    .catch(err => {
                        console.error("Error fetching merchant session", err);
                    });
            },
            onPaymentAuthorized(event) {
                console.log("On payment authorized, payload: " + event.payment);
                this.setApplePayToken(event.payment.token);
                this.setPaymentProvider("ApplePay");
                this.session.completePayment({
                    status: 0
                });
                this.nextStep();
            },
            onCancel() {
                console.log("on cancel");
            },
            onClickHandler() {
                console.log(this.getApplePayPaymentRequest())
                this.session = new ApplePaySession(3, this.getApplePayPaymentRequest());
                this.session.onvalidatemerchant = this.onValidateMerchant;
                this.session.onpaymentauthorized = this.onPaymentAuthorized;
                this.session.oncancel = this.onCancel;
                console.log("calling session begin");
                this.session.begin();
            },
            setApplePayToken(token) {
                this.$store.commit("order/setApplePayToken", token);
            },
            setPaymentProvider(provider) {
                this.$store.commit("order/setPaymentProvider", provider);
            },
            ...mapActions({
                nextStep: "flow/gotoNextStep"
            }),
        }
    };
</script>

<style scoped>

    .apple-pay-button {
        display: inline-block;
        cursor: pointer;
        -webkit-appearance: -apple-pay-button;
        -apple-pay-button-type: buy;
    }

    .apple-pay-button-black {
        -apple-pay-button-style: black;
    }

    .apple-pay-button-white {
        -apple-pay-button-style: white;
    }

    .apple-pay-button-white-with-line {
        -apple-pay-button-style: white-outline;
    }

</style>
